import React from "react";
import {Container, MainContainer, SectionContainer} from "../../CommonStyled/widgets/Styled";
import ReviewTopSection from "./widgets/TopSection";
import ReviewCard from "./widgets/ReviewCard";
import PropTypes from "prop-types";
import {ReviewCardContentLoader} from "./widgets/ContentLoaderPage";
import {elementOffset} from "../../../utils/utils";
import Banner from "../Banner";
import StructuredData from "../../../utils/googleStructuredData";
import {getAbsoluteStudyAbroadURL} from "../../../utils/utils";

class CounselingReview extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.loadOnScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.loadOnScroll);
    }

    loadOnScroll = () => {
        if (this.props.reviewList.length >= this.props.counselingReviewData.totalNumFound) {
            window.removeEventListener("scroll", this.loadOnScroll);
        }
        const id = document.getElementById("content-end");
        const el = elementOffset(id);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop + window.innerHeight > el.top) {
            this.props.loadMore();
        }
        // let footer = document.getElementById('headerStickyEnd');

        // let rect = el.getBoundingClientRect();
        // let isAtEnd = (
        //     rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        //     rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        // );

        // let rectFooter = footer.getBoundingClientRect();
        // let isAtFooterEnd = (
        //     rectFooter.bottom+200 <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        //     rectFooter.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        // );

        // if(isAtEnd && !isAtFooterEnd){
        //     this.props.loadMore();
        // }
    };

    getSnapshotBeforeUpdate(prevProps) {
        // Are we adding new items to the list?
        // Capture the scroll position so we can adjust scroll later.
        if (prevProps.reviewList.length < this.props.reviewList.length) {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // If we have a snapshot value, we've just added new items.
        // Adjust scroll so these new items don't push the old ones out of view.
        // (snapshot here is the value returned from getSnapshotBeforeUpdate)
        if (snapshot !== null) {
            window.scrollTo(0, snapshot);
        }
    }

    renderReviewCards = () => {
        return this.props.reviewList.map((review, index) => {
            return (
                <React.Fragment key={`reviewCard${index}`}>
                    {index === 3 && <Banner />}
                    <ReviewCard review={review} />
                </React.Fragment>
            );
        });
    };

    render() {
        const {counselingRatingData} = this.props;
        const seoData = counselingRatingData?.seoData ?? {};
        const reviewCount =
            counselingRatingData?.counsellingRatingData?.counsellingRatingData?.ratingCount ?? 0;
        const ratingValue =
            counselingRatingData?.counsellingRatingData?.counsellingRatingData?.overallRating ?? 0;

        const googleSchemaReview = () => {
            return (
                <StructuredData
                    type="Product"
                    data={{
                        url: getAbsoluteStudyAbroadURL(seoData?.canonical ?? ""),
                        name: seoData?.title ?? "",
                        description: seoData?.description ?? "",
                        aggregateRating: {
                            "@type": "AggregateRating",
                            bestRating: "5",
                            ratingValue: ratingValue.toString(),
                            reviewCount: reviewCount.toString(),
                            worstRating: "1",
                        },
                    }}
                />
            );
        };
        return (
            <Container>
                {googleSchemaReview()}
                <MainContainer
                    containerStyle={{
                        mobile: {margin: ""},
                        laptop: {margin: "38px auto 0"},
                    }}
                >
                    <SectionContainer
                        sectionContainerStyle={{
                            mobile: {maxWidth: ""},
                            laptop: {maxWidth: "970px"},
                        }}
                    >
                        <ReviewTopSection
                            data={this.props.counselingRatingData.counsellingRatingData}
                            doSort={this.props.doSort}
                            sortType={this.props.sortType}
                            userLoggedIn={this.props.userLoggedIn}
                            isMobile={this.props.isMobile}
                        />
                        {this.props.showCardContentLoader ? (
                            <ReviewCardContentLoader />
                        ) : (
                            this.renderReviewCards()
                        )}
                        <div id="content-end"></div>
                        {this.props.reviewList.length !==
                            this.props.counselingReviewData.totalNumFound && (
                            <ReviewCardContentLoader />
                        )}
                    </SectionContainer>
                </MainContainer>
            </Container>
        );
    }
}
CounselingReview.propTypes = {
    counselingRatingData: PropTypes.object,
    counselingReviewData: PropTypes.object,
    doSort: PropTypes.func,
    loadMore: PropTypes.func,
    sortType: PropTypes.string,
    reviewList: PropTypes.array,
    userLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
    showCardContentLoader: PropTypes.bool,
};

export default CounselingReview;
